module.exports = __webpack_public_path__ + "media/images/webpage/pages/about/section-2-0c7eb9ae16146c6262770fa17725f902.webp";